import { DateField } from '@components/Fields/DateField';
import { Fieldset } from '@components/Fields/Fieldset';
import { FloatField } from '@components/Fields/FloatField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { StringField } from '@components/Fields/StringField';
import { VerticalGrid } from '@components/VerticalGrid';
import { IForm } from '@hooks/useForm';
import { IContratoCliente } from '@model/ContratoCliente';
import React from 'react';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';

export type ContratoClienteEditarFormularioProps = {
    form: IForm<Partial<IContratoCliente>>

}

export function ContratoClienteEditarFormulario ({ form }: ContratoClienteEditarFormularioProps) {
    const { fields } = form;

    return (
        <VerticalGrid>
            <Fieldset
                icon={<AssignmentIndIcon />}
                title="Parâmetros"
                hasMarginTop={false}
            >
                <HorizontalGrid spacing={2}>
                    <GridItem xs={3}>
                        <DateField
                            field={fields.inicio}
                            label="Início"
                            required
                            disabled
                        />
                    </GridItem>

                    <GridItem xs={3}>
                        <FloatField
                            field={fields.valorPlano}
                            label="Valor Plano"
                            required
                        />
                    </GridItem>

                    <GridItem xs={3}>
                        <FloatField
                            field={fields.valorAssessoria}
                            label="Valor Consultoria"
                            required
                        />
                    </GridItem>

                    <GridItem xs={3}>
                        <FloatField
                            field={fields.franquiaGb}
                            label="Franguia GB"
                            required
                        />
                    </GridItem>

                    <GridItem xs={3}>
                        <FloatField
                            field={fields.valorChip}
                            label="Valor Chip"
                            required
                            disabled
                        />
                    </GridItem>

                    <GridItem xs={3}>
                        <FloatField
                            field={fields.valorChipDescontado}
                            label="Valor Chip Cobrar"
                            required
                        />
                    </GridItem>
                </HorizontalGrid>
            </Fieldset>

            <Fieldset
                icon={<ImportContactsIcon />}
                title="Outras Informações"
            >
                <HorizontalGrid spacing={2}>
                    <GridItem xs={12}>
                        <StringField 
                            field={fields.usuarioLinha}
                            label="Usuário da Linha"
                        />
                    </GridItem>

                    <GridItem xs={12}>
                        <StringField 
                            field={fields.notas}
                            label="Notas"
                            multiline
                        />
                    </GridItem>
                </HorizontalGrid>
            </Fieldset>
       </VerticalGrid>
    )
}